<template>
  <div class="wl-skeleton h-4 rounded-2xl" />
</template>

<style>
@reference "@theme";

.wl-skeleton {
  @apply bg-muted relative z-10 overflow-hidden;

  &:before {
    @apply absolute inset-0 size-full -translate-x-full animate-[wl-skeleton_1s_infinite] bg-gradient-to-l from-white/25 to-white/0 content-[''];
  }
}

/**
 * NOTE: The `@apply` is not used here as Chrome (114.0.5735.90) does not
 * support CSS variables within @keyframes.
 */
@keyframes wl-skeleton {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}
</style>
